<div class="vd-page">
  <div class="vd-card">

    <!-- ── CARGANDO ── -->
    <ng-container *ngIf="cargando">
      <div class="vd-banner loading">
        <div class="vd-icon-circle">
          <mat-progress-spinner mode="indeterminate" diameter="28"
            style="display:inline-block;"></mat-progress-spinner>
        </div>
        <h2>Verificando documento...</h2>
        <p>Por favor espera un momento.</p>
      </div>
    </ng-container>

    <!-- ── VÁLIDO ── -->
    <ng-container *ngIf="!cargando && valido && datos">

      <div class="vd-banner valid">
        <div class="vd-icon-circle">
          <mat-icon>check</mat-icon>
        </div>
        <h2>Documento Verificado</h2>
        <p>
          Este {{ datos.tipoDoc === 'HISTORIAL' ? 'historial académico' : 'certificación académica' }}
          es auténtico y fue generado por el sistema DIPP-UNAH
        </p>
      </div>

      <div class="vd-body">

        <div class="vd-verified-badge">
          <mat-icon>verified</mat-icon>
          VERIFICADO POR UNAH &mdash; SISTEMA DIPP
        </div>

        <!-- Nombre -->
        <div class="vd-field">
          <div class="vd-field-label">Nombre del Estudiante</div>
          <div class="vd-field-value">{{ datos.nombre }}</div>
        </div>

        <!-- Cuenta + Centro -->
        <div class="vd-row">
          <div class="vd-field green">
            <div class="vd-field-label">No. Cuenta</div>
            <div class="vd-field-value">{{ datos.cuenta }}</div>
          </div>
          <div class="vd-field green">
            <div class="vd-field-label">Centro Universitario</div>
            <div class="vd-field-value">{{ datos.centro }}</div>
          </div>
        </div>

        <!-- Carrera -->
        <div class="vd-field orange">
          <div class="vd-field-label">Carrera</div>
          <div class="vd-field-value">{{ datos.carrera }}</div>
        </div>

        <!-- Info del documento -->
        <div class="vd-doc-info">
          <div class="vd-doc-info-title">
            <mat-icon>description</mat-icon>
            Información del Documento
          </div>
          <div class="vd-doc-info-row">
            <span>ID:</span>{{ datos.docId }}
            &nbsp;&nbsp;
            <span>Generado:</span>{{ datos.fechaGeneracion }}
            &nbsp;&nbsp;
            <span>Tipo:</span>{{ tipoDocLabel() }}
          </div>
        </div>

        <!-- Botón de descarga -->
        <a *ngIf="datos.downloadUrl"
           [href]="datos.downloadUrl"
           target="_blank"
           class="vd-download-btn">
          <mat-icon>file_download</mat-icon>
          Descargar Documento Original desde UNAH
        </a>
        <p class="vd-expiry" *ngIf="datos.downloadUrl">
          <mat-icon>schedule</mat-icon>
          El enlace de descarga expira en <strong> 15 minutos</strong>
        </p>

        <!-- Footer -->
        <div class="vd-footer">
          <strong>Universidad Nacional Autónoma de Honduras</strong><br>
          Dirección de Ingreso, Permanencia y Promoción &mdash; DIPP<br>
          Sistema de Verificación de Documentos Académicos
        </div>

      </div>
    </ng-container>

    <!-- ── INVÁLIDO ── -->
    <ng-container *ngIf="!cargando && !valido">
      <div class="vd-banner invalid">
        <div class="vd-icon-circle">
          <mat-icon>error_outline</mat-icon>
        </div>
        <h2>Documento No Encontrado</h2>
        <p>El código QR escaneado no corresponde a ningún documento oficial.</p>
      </div>
      <div class="vd-invalid-body">
        <p>
          El documento con ID <strong>{{ docId }}</strong> no existe en nuestro sistema
          o no ha sido validado correctamente.
        </p>
        <p>Si crees que esto es un error, contacta a la DIPP-UNAH.</p>
        <div class="vd-footer">
          <strong>Universidad Nacional Autónoma de Honduras</strong><br>
          Dirección de Ingreso, Permanencia y Promoción &mdash; DIPP
        </div>
      </div>
    </ng-container>

  </div>
</div>
